import { NotificationsDropdownComponent } from "./notificationsDropdown";

export const NotificationsDropdown = NotificationsDropdownComponent;
